// Name field validator

export default ({ mandatory = false, customError = null }) => ({
  /** Other than english is not supported, so commented intentionally */
  // format: /^[a-z ,.'-]+$/i,
  type: 'string',
  presence: mandatory && { message: customError }
});
